import { readUwData } from './mappers';

/**
 * One shared promise per cache key for a BEFE read mapped to `T`. A failed or unusable response
 * resolves to null and is evicted, so the next caller retries instead of reusing the failure.
 */
export function loadCachedBefeData<U, T>(
    cache: Map<string, Promise<T | null>>,
    key: string,
    fetchBody: () => Promise<unknown>,
    serviceId: string,
    toResult: (data: U) => T,
): Promise<T | null> {
    const cached = cache.get(key);
    if (cached) return cached;

    const promise = fetchBody()
        .then((body) => {
            const data = readUwData<U>(body, serviceId);
            return data ? toResult(data) : null;
        })
        .catch(() => null)
        .then((result) => {
            if (!result && cache.get(key) === promise) cache.delete(key);
            return result;
        });
    cache.set(key, promise);
    return promise;
}
